<template>
  <div class="basic-info">
    <!-- 主站微简历且未登录态 -->
    <login-guide
      v-if="['fromWX', 'fromBD', 'fromZFB', 'fromTT'].indexOf(pagefrom) === -1  && (resumeType === 2 && !isLogin)"
    ></login-guide>
    <head-portrait></head-portrait>
    <div class="basic-info-box">
      <name ref="truename"></name>
      <sex ref="gender"></sex>
      <mobile ref="mobile" v-show="isLogin"></mobile>
      <login-captcha ref="loginMobile" v-show="!isLogin"></login-captcha>
      <experience ref="experience"></experience>
    </div>
    <!-- 教育经历 -->
    <div class="basic-education" v-if="needEducation">
      <my-education></my-education>
    </div>
    <div class="basic-info-save-box">
      <div class="page-btn" @click="nextStep" :class="{'btn-disabled': !basicInfoOk}">保存</div>
    </div>
    <toast v-model="errorTip" :time="time">{{errorInfo}}</toast>
    <my-dialog
      v-if="showStay"
      title="提示"
      content="离好工作仅差一步，是否确认退出？"
      btnCancel="确定退出"
      btnConfirm="继续填写"
      @cancel="quit"
      @confirm="noQuit"
    ></my-dialog>
    <my-dialog
      v-if="showLimit"
      title="提示"
      content="您的简历已达到上限了哦"
      btnCancel="查看职位"
      btnConfirm="查看简历"
      @cancel="goJobList"
      @confirm="goMyResume"
    ></my-dialog>
  </div>
</template>
<script>
import loginGuide from "./loginGuide";
import headPortrait from "./headPortrait";
import name from "./name";
import sex from "./sex";
import mobile from "./mobile/mobile";
import loginCaptcha from "./mobile/loginCaptcha";
import experience from "./experience";
import myEducation from "./education";
import { LoadSDK } from "./LoadSDK";
import { LimitFn } from "./LimitFn";
import myDialog from "../common/myDialog";
import config from "../../util/config";
import cookie from "../../util/cookie";
import Cookies from 'js-cookie';
import util from "../../util";
import backAlert from "../../util/backAlert";
import eduMixin from "../../mixins/eduMixin";
import * as types from "../../store/mutation-types";
import { Toast } from "@58fe/v5";
import { mapGetters } from "vuex";

export default {
  components: {
    loginGuide,
    headPortrait,
    name,
    sex,
    mobile,
    loginCaptcha,
    experience,
    myEducation,
    Toast,
    myDialog
  },
  data() {
    return {
      nameObj: {
        truename: "姓名",
        gender: "性别",
        mobile: "手机号",
        keyCode: "验证码",
        birthday: "出生年份",
        education: "最高学历",
        workyears: "工作时间",
        educations: "教育经历"
      },
      errorTip: false,
      errorInfo: "",
      showStay: false,
      showLimit: false,
      time: 1500,
      limitObj: null
    };
  },
  mixins: [eduMixin],
  created() {
    this.limitObj = new LimitFn(this.pagefromUrl, this.$v5);

    // 加载sdk
    let loadSDK = new LoadSDK();
    loadSDK[this.pagefrom] && loadSDK[this.pagefrom]();

    let ppu = util.getParamVal("ppu"); //已登录进入，URL中携带PPU信息，将PPU信息写入cookie
    if (ppu) {
      Cookies.set('PPU', decodeURIComponent(ppu), { domain: '58.com', expires: 7 }); // 小程序跳转来的设置登录态

      // 更改登录状态
      this.$store.commit(types.CHANGE_LOGINSTATE, true);
    }

    if (this.isLogin) {
      // 获取简历份数
      this.$store.dispatch("getResumeCount", cookie.getname("PPU", "UID"));

      if (this.areaInfo.length < 1) {
        // 获取上一份简历基本信息
        this.$store.dispatch("getLastResumeInfo");

        // 获取账号绑定的手机号
        this.$store.dispatch("checkMobileAuth");

        // 获取用户隐私设置
        this.$store.dispatch("getPrivacy");
      }
    }
    if (this.areaInfo.length < 1) {
      this.$store.dispatch("getAreaInfo");
    }
  },
  computed: {
    ...mapGetters([
      "basicInfoOk",
      "basicInfo",
      "isLogin",
      "resumeType",
      "resumeCount",
      "jobUrl",
      "pagefromUrl",
      "pagefromLog",
      "pagetypeLog",
      "deliveryCode",
      "education",
      "workyears",
      "pagefrom",
      "areaInfo"
    ]),
    // 教育经历是否必填
    needEducation() {
      // 大专及以上 + 校招 + 应届生必填
      return (
        this.education > 3 &&
        (this.pagefrom === "fromXZ" || this.pagefrom === "fromCQXZ") &&
        this.workyears === 5
      );
    }
  },
  watch: {
    resumeCount(val) {
      if (val < 3) {
        return;
      }
      // 当简历份数达到3份上限时则提示引导
      if (this.pagefrom == "default") {
        this.showLimit = true;
        return;
      }
      this.limitObj[this.pagefrom]();
    }
  },
  mounted() {
    // 挽留弹窗展现
    if (
      ["fromWX", "fromBD", "fromZFB", "fromTT", "fromTZ"].indexOf(this.pagefrom) === -1
    ) {
      backAlert(() => {
        this.showStay = true;
      }, this.pagefromLog);
    }

    // 添加按下态监听
    let basicList = Array.prototype.slice.call(
        document.getElementsByClassName("basic-info-detail")
      ),
      sexList = Array.prototype.slice.call(
        document.getElementsByClassName("user-sex")
      ),
      chooseList = Array.prototype.slice.call(
        document.getElementsByClassName("choose-detail")
      ),
      DomList = basicList.concat(sexList, chooseList);

    DomList.forEach((item, index) => {
      item.addEventListener("touchstart", function(e) {
        this.parentNode.className += " item-active";
      });
      item.addEventListener("touchmove", function(e) {
        this.parentNode.className = this.parentNode.className.replace(
          /item-active/g,
          ""
        );
      });
      item.addEventListener("touchend", function(e) {
        this.parentNode.className = this.parentNode.className.replace(
          /item-active/g,
          ""
        );
      });
    });
    // 渠道来源埋点
    const sourceid = util.getParamVal("sourceid");
    window.clickLog && window.clickLog("from=qudao_from_" + sourceid);

    // 校招来源埋点
    this.pagefrom === "fromXZ" &&
      window.clickLog &&
      window.clickLog("from=xiaozhao_resumecreate1_show");
    this.pagefrom === "fromCQXZ" &&
      window.clickLog &&
      window.clickLog("from=chongqingxiaozhao_resumecreate1_show");

    setTimeout(()=>{
      //mp从小程序我的页面进入
      const fromPageName = util.getParamVal("platform") || ""
      if(this.pagefrom === "fromWX" && fromPageName === "mp"){
        window.clickLog &&
        window.clickLog("from=58yg_nojlpost_page1_show");
      }else if(this.pagefrom === "fromWX"){
        window.clickLog &&
        window.clickLog("from=58yg_jlpost_page1_show");
      }
    }, 200)
  },
  methods: {
    nextStep() {
      // 按钮点击，不区分可点击态
      window.clickLog &&
        window.clickLog("from=jl_basicsaveall_all" + this.pagetypeLog);
      window.clickLog &&
        window.clickLog("from=jl_basicsaveall" + this.pagefromLog);

      if (this.basicInfoOk) {//高亮
        /*
        *简历发布来源：微信：70百度：71头条：70支付宝：70
        */
        if([70,71].indexOf(parseInt(util.getParamVal('sourceid'),10)) > -1) {
          window.clickLog && clickLog("from=page1_save_click");
        }

        window.clickLog &&
          window.clickLog("from=jl_basicsave_all" + this.pagetypeLog);
        window.clickLog &&
          window.clickLog("from=jl_basicsave" + this.pagefromLog);

        // 校招来源保存埋点
        this.pagefrom === "fromXZ" &&
          window.clickLog &&
          window.clickLog("from=xiaozhao_resumecreate_save");
        this.pagefrom === "fromCQXZ" &&
          window.clickLog &&
          window.clickLog("from=chongqingxiaozhao_resumecreate_save");

        window.history.pushState({}, "", ""); // 防止跳转之后点击返回再次弹出提示框
        this.$router.push("expectation");
      } else {
        // 未填写的项进行错误提示
        let obj = this.basicInfo,
          isFirstError = true;

        for (let prop in obj) {
          // 第一个错误信息toast提示，错误样式处理只需触发为空的项
          if (isFirstError && obj.hasOwnProperty(prop) && !obj[prop]) {
            this.errorInfo = "您的" + this.nameObj[prop] + "填写有误，请修改";
            this.errorTip = true;
            isFirstError = false;
          }
          if (
            obj.hasOwnProperty(prop) &&
            obj[prop] === null &&
            prop !== "keyCode"
          ) {
            // 多选弹框
            if (
              prop === "birthday" ||
              prop === "education" ||
              prop === "workyears"
            ) {
              this.$refs.experience.checkNull(prop);
            } else if (prop === "mobile" && !this.isLogin) {
              this.$refs.loginMobile.checkNull();
            } else {
              this.$refs[prop].checkNull();
            }
          }
        }
      }
    },
    quit() {
      this.showStay = false;
      window.clickLog &&
        window.clickLog("from=jianli_post_no_full" + this.pagefromLog);

      // 从发布完成页或完善页返回回来的再次点击回退需回退三步
      window.history.go(-1);
    },
    noQuit() {
      this.showStay = false;
      window.history.pushState({}, "", "");

      window.clickLog &&
        window.clickLog("from=jianli_post_yes_full" + this.pagefromLog);
    },
    goMyResume() {
      window.location.href =
        config.jlDomain + "/resumeupdate/resumelist?from=publish";
    },
    goJobList() {
      if (this.resumeType === 3) {
        window.location.replace(this.pagefromUrl);
      } else {
        window.location.href = this.jobUrl;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.resetEdu(); // 重置教育经历信息
    next();
  }
};
</script>
<style lang='scss'>
@import "../../assets/style/public";

.basic-info {
  background: #fff;
  width: 100%;
  .basic-education {
    padding-top: px2rem(20px);
    background: #f6f6f6;
  }
}

.basic-info-box {
  padding: px2rem(100px) 0 0;
}

.basic-info-detail {
  a {
    font-size: px2rem(38px);
    vertical-align: middle;
  }
}

.basic-info-save-box {
  background: #f6f6f6;
  padding: px2rem(40px) 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?29b3367e